import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../../common/helpers/common.utils.js";
const ContentLayout = forwardRef((props, ref) => {
  const { children, includeSidebarPadding = true, includeNavbarPadding = true, className, ...rest } = props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    includeNavbarPadding && /* @__PURE__ */ jsx("div", { className: "pt-[var(--navbar-height)]" }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ...rest,
        ref,
        className: cn("p-5", includeSidebarPadding && "ml-[var(--sidebar-width)]", className),
        children
      }
    )
  ] });
});
export {
  ContentLayout as default
};
//# sourceMappingURL=ContentLayout.js.map
